/* site-analytics.js — storefront GA4 upper-funnel events → dataLayer (via GTM).
   dataLayer trigger names stay site_* (internal); GTM tags map them to STANDARD GA4
   ecommerce names so "Send Ecommerce data" attaches items. Payloads NEVER carry
   price/value/currency (site-wide anti-scrape invariant). Campaign pages (page_type
   "page") are never injected — campaign_* pipeline owns them. */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__siteAnalyticsBound) return;
  window.__siteAnalyticsBound = true;

  var PAGE_TYPES = { index: 1, collection: 1, search: 1, product: 1, cart: 1 };
  var IO_THRESHOLD = 0.5;
  var IMPRESSION_DEBOUNCE_MS = 600; // batch list impressions
  var RESCAN_DEBOUNCE_MS = 300;     // MutationObserver rescan (dynamic DOM: recommendations AJAX, facet rerender)
  var ATC_QUIET_MS = 150;           // add-to-cart quiet window after in-flight reaches zero
  var MAX_ITEMS_PER_PUSH = 24;

  function pageType() {
    try {
      var tv = window.themeVariables;
      return (tv && tv.settings && tv.settings.pageType) || '';
    } catch (e) { return ''; }
  }
  var pt = pageType();
  if (!PAGE_TYPES[pt]) return;

  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
    } catch (e) {}
    return true;
  }

  function asString(v) { return v == null ? '' : String(v); }

  function readIsland(id) {
    try {
      var el = document.getElementById(id);
      if (el && el.textContent) return JSON.parse(el.textContent);
    } catch (e) {}
    return null;
  }

  function normalizeItem(raw, listId) {
    var item = {
      item_id: asString(raw.item_id),
      item_name: asString(raw.item_name),
      quantity: Number(raw.quantity || 1)
    };
    if (listId) item.item_list_id = listId;
    if (raw.product_series) item.product_series = asString(raw.product_series);
    return item;
  }

  function pushEvent(eventName, items, listId) {
    if (!analyticsAllowed()) return;
    items = items || [];
    if (!items.length && eventName !== 'site_view_cart') return; // empty cart still fires
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    var payload = { event: eventName, ecommerce: { items: items } };
    if (listId) { payload.list_id = listId; payload.ecommerce.item_list_id = listId; }
    window.dataLayer.push(payload);
  }

  /* ---------- PDP view_item ---------- */
  function firePdpView() {
    var island = readIsland('site-analytics-item');
    if (!island || !island.item_id) return;
    pushEvent('site_view_item', [normalizeItem(island)]);
  }

  /* ---------- cart view_cart ---------- */
  function fireCartView() {
    var island = readIsland('site-analytics-cart');
    if (!island || !Array.isArray(island)) return;
    var items = [];
    for (var i = 0; i < island.length; i++) items.push(normalizeItem(island[i]));
    pushEvent('site_view_cart', items);
  }

  /* ---------- list impressions: IO + batching + MutationObserver rescan ---------- */
  var observed = (typeof WeakSet === 'function') ? new WeakSet() : null;
  var fired = (typeof WeakSet === 'function') ? new WeakSet() : null;
  var pendingImpressions = []; // { listId, item }
  var impressionTimer = null;
  var io = null;

  function cardData(card) {
    return {
      item_id: card.getAttribute('data-sa-id'),
      item_name: card.getAttribute('data-sa-name'),
      product_series: card.getAttribute('data-sa-series') || undefined,
      quantity: 1
    };
  }

  function listIdOf(el) {
    var host = el.closest && el.closest('[data-sa-list]');
    return host ? (host.getAttribute('data-sa-list') || '') : '';
  }

  function flushImpressions() {
    impressionTimer = null;
    if (!pendingImpressions.length) return;
    var groups = {};
    for (var i = 0; i < pendingImpressions.length; i++) {
      var p = pendingImpressions[i];
      (groups[p.listId] = groups[p.listId] || []).push(p.item);
    }
    pendingImpressions = [];
    for (var listId in groups) {
      var items = groups[listId];
      for (var s = 0; s < items.length; s += MAX_ITEMS_PER_PUSH) {
        pushEvent('site_view_item_list', items.slice(s, s + MAX_ITEMS_PER_PUSH), listId);
      }
    }
  }

  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (!entry.isIntersecting) continue;
      var card = entry.target;
      io.unobserve(card);
      if (fired) { if (fired.has(card)) continue; fired.add(card); }
      var listId = listIdOf(card);
      if (!listId) continue; // whitelist: cards outside data-sa-list containers are never tracked
      pendingImpressions.push({ listId: listId, item: normalizeItem(cardData(card), listId) });
    }
    if (pendingImpressions.length && !impressionTimer) impressionTimer = setTimeout(flushImpressions, IMPRESSION_DEBOUNCE_MS);
  }

  function observeCards() {
    if (!io) return;
    var cards = document.querySelectorAll('[data-sa-list] [data-sa-id]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (observed) { if (observed.has(card)) continue; observed.add(card); }
      io.observe(card);
    }
  }

  var rescanTimer = null;
  function scheduleRescan() {
    if (rescanTimer) return;
    rescanTimer = setTimeout(function () { rescanTimer = null; observeCards(); }, RESCAN_DEBOUNCE_MS);
  }

  function initListTracking() {
    if (typeof IntersectionObserver !== 'function') return;
    io = new IntersectionObserver(onIntersect, { threshold: IO_THRESHOLD });
    observeCards();
    if (typeof MutationObserver === 'function') {
      new MutationObserver(scheduleRescan).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var card = t.closest('[data-sa-id]');
      if (!card) return;
      var listId = listIdOf(card);
      if (!listId) return; // whitelist ruling — same scope as impressions
      if (t.closest('form, button, input, select, label, [data-action]')) return; // quick-add / compare / swatch are not select_item
      pushEvent('site_select_item', [normalizeItem(cardData(card), listId)], listId);
    }, true); // capture: runs synchronously before navigation
  }

  /* ---------- add_to_cart: fetch interception + in-flight aggregation ---------- */
  var pendingAtc = [];
  var atcInflight = 0;
  var atcTimer = null;

  function pdpSeriesFor(productId) {
    var island = readIsland('site-analytics-item');
    if (island && asString(island.item_id) === asString(productId)) return island.product_series;
    return undefined;
  }

  function flushAtc() {
    atcTimer = null;
    if (atcInflight > 0 || !pendingAtc.length) return;
    var items = pendingAtc;
    pendingAtc = [];
    pushEvent('site_add_to_cart', items);
  }

  function scheduleAtcFlush() {
    if (atcTimer) { clearTimeout(atcTimer); atcTimer = null; }
    if (atcInflight > 0) return; // another request still running; its settle will reschedule
    atcTimer = setTimeout(flushAtc, ATC_QUIET_MS);
  }

  function collectAtcResponse(data) {
    var raw = (data && data.items) ? data.items : (data && data.id ? [data] : []);
    for (var i = 0; i < raw.length; i++) {
      var r = raw[i] || {};
      pendingAtc.push(normalizeItem({
        item_id: r.product_id,
        item_name: r.product_title || r.title,
        product_series: pdpSeriesFor(r.product_id),
        quantity: r.quantity
      }));
    }
  }

  function flushAtcOnHide() {
    if (atcTimer) { clearTimeout(atcTimer); atcTimer = null; }
    if (pendingAtc.length) { // confirmed items only; in-flight (unconfirmed) never entered pendingAtc → dropped by design
      var items = pendingAtc;
      pendingAtc = [];
      pushEvent('site_add_to_cart', items);
    }
  }

  function initAtcTracking() {
    if (typeof window.fetch !== 'function') return;
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = (typeof input === 'string') ? input : ((input && input.url) || ''); } catch (e) {}
      var isCartAdd = url.indexOf('/cart/add') !== -1;
      if (isCartAdd) {
        atcInflight++;
        if (atcTimer) { clearTimeout(atcTimer); atcTimer = null; } // new request cancels pending flush
      }
      var p = _fetch.apply(this, arguments);
      if (isCartAdd) {
        p.then(function (res) {
          if (res && res.ok) {
            try {
              res.clone().json().then(function (data) {
                collectAtcResponse(data);
                atcInflight--; // settle only after body parsed — confirmed means "data collected"
                scheduleAtcFlush();
              }).catch(function () { atcInflight--; scheduleAtcFlush(); });
            } catch (e) { atcInflight--; scheduleAtcFlush(); }
          } else {
            atcInflight--;
            scheduleAtcFlush(); // failed add: nothing collected
          }
        }, function () {
          atcInflight--;
          scheduleAtcFlush();
        });
      }
      return p; // original fetch semantics always preserved
    };
    window.addEventListener('pagehide', flushAtcOnHide);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flushAtcOnHide();
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    if (pt === 'product') firePdpView();
    if (pt === 'cart') fireCartView();
    initListTracking();
    initAtcTracking();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
